/**
 * Remembers the last reader location so "Back to reader" (top bar, sidebar, Escape) returns to it with
 * its message, the way the prototype restores `readerReturn`.
 */

let lastReader = '/';

export function rememberReaderPath(path: string): void {
  lastReader = path;
}

export function lastReaderPath(): string {
  return lastReader;
}
